import {
  DISPLAY_CENTER_SAVE_BUTTON,
  DISPLAY_CENTERS_DROPDOWN_LIST,
  DISPLAY_THEMES,
  DISPLAY_TIME_ZONES,
  SET_CAN_ASSIGN_TAG,
  SET_CAN_DELETE_TAG,
  SET_CARDS,
  SET_CARD_SELECTION,
  SET_IS_ADDING_TAG,
  SET_IS_NEW_TOURNAMENT,
  SET_LOCATION_CERTIFICATION_NUMBER,
  SET_STRIPE_ACCOUNTS,
  SET_STRIPE_ACCOUNT_SELECTION,
  SET_TAG_INDEX,
  SET_AVAILABLE_TAGS,
  SET_TOURNAMENT_EXPORT_OPTIONS_IN_STATE,
  SET_TOURNAMENT_EXPORT_SELECTION_IN_STATE,
  SET_TOURNAMENT_LOCATION_EDITING,
  SET_TOURNAMENT_LOCATION_NAME_VALUE,
  SET_TOURNAMENT_LOCATION_SEARCH_RESULTS,
  SET_TOURNAMENT_LOCATIONS_IN_STATE,
  SET_TOURNAMENT_TAGS,
  SET_IS_SUPER_USER
} from './constants';

const initialState = {
  timeZones: [],
  managers: [],
  restrictions: [],
  tags: [],
  tagIndex: null,
  cards: [],
  themes: [],
  locations: [],
  exportOptions: [],
  exportSelection: null,
  stripeAccounts: [],
  cardSelection: null,
  stripeAccountSelection: null,
  locationSearchResults: []
};

const reducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case DISPLAY_CENTER_SAVE_BUTTON: {
      return {
        ...state,
        saveable: payload || initialState.saveable
      };
    }

    case DISPLAY_CENTERS_DROPDOWN_LIST: {
      return {
        ...state,
        selectable: payload || initialState.selectable
      };
    }

    case DISPLAY_THEMES:
      return {
        ...state,
        themes: payload
      };

    case DISPLAY_TIME_ZONES:
      return {
        ...state,
        timeZones: payload
      };

    case SET_CAN_ASSIGN_TAG: {
      return {
        ...state,
        canAssignTag: payload
      };
    }
    
    case SET_CAN_DELETE_TAG: {
      return {
        ...state,
        canDeleteTag: payload
      };
    }

    case SET_CARDS: {
      return {
        ...state,
        cards: payload || initialState.cards
      };
    }

    case SET_CARD_SELECTION: {
      return {
        ...state,
        cardSelection: payload || initialState.cardSelection
      };
    }

    case SET_IS_ADDING_TAG: {
      return {
        ...state,
        isAddingTag: payload || initialState.isAddingTag
      };
    }

    case SET_IS_NEW_TOURNAMENT: {
      return {
        ...state,
        isNewTournament: payload
      };
    }

    case SET_LOCATION_CERTIFICATION_NUMBER: {
      return {
        ...state,
        certificationNumber: payload || initialState.certificationNumber        
      };      
    }

    case SET_STRIPE_ACCOUNT_SELECTION: {
      return {
        ...state,
        stripeAccountSelection: payload || initialState.stripeAccountSelection
      };
    }
    
    case SET_STRIPE_ACCOUNTS:
      return {
        ...state,
        stripeAccounts: payload || initialState.stripeAccounts
      };

    case SET_AVAILABLE_TAGS: {
      const tags = payload || initialState.tags;

      // Add editing flag
      tags.forEach(x => x.editing = false);

      return {
        ...state,
        tags: tags
      };
    }

    case SET_TAG_INDEX: { 
      return {
        ...state,
        tagIndex: payload || initialState.tagIndex
      };
    }

    case SET_TOURNAMENT_EXPORT_OPTIONS_IN_STATE: {
      return {
        ...state,
        exportOptions: payload || initialState.exportOptions
      };
    }

    case SET_TOURNAMENT_EXPORT_SELECTION_IN_STATE: {
      return {
        ...state,
        exportSelection: payload || initialState.exportSelection
      };
    }

    case SET_TOURNAMENT_LOCATION_EDITING: {
      return {
        ...state,
        locations: state.locations.map(m => {
          return m.id == payload ? {...m, editing: !m.editing} : {...m, editing: false};
        })
      };
    }

    case SET_TOURNAMENT_LOCATION_NAME_VALUE:
      return {
        ...state,
        locationName: payload
      }; 

    case SET_TOURNAMENT_LOCATION_SEARCH_RESULTS: {
      return {
        ...state,
        locationSearchResults: payload || initialState.locationSearchResults        
      };      
    }

    case SET_TOURNAMENT_LOCATIONS_IN_STATE: {
      const locations = payload || initialState.managers;

      // Add editing flag
      locations.forEach(m => m.editing = false);

      return {
        ...state,
        locations: locations
      };
    }

    case SET_TOURNAMENT_TAGS: {
      return {
        ...state,
        tournamentTags: payload
      };
    }

    case SET_IS_SUPER_USER: {
      return {
        ...state,
        isSuperUser: payload
      };
    }

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/features/tournament/general/reducer.js